.up {
  transform: rotate(180deg);
  transition: 0.1s ease-in-out;
}

.down {
  transform: rotate(0deg);
  transition: 0.1s ease-in-out;
}

.right {
  transform: rotate(270deg);
  transition: 0.1s ease-in-out;
}

.left {
  transform: rotate(90deg);
  transition: 0.1s ease-in-out;
}

.md {
  width: 15px;
  height: 15px;
}

.sm {
  width: 10px;
  height: 10px;
}

.loading {
  display: block;
  margin: 0px 8px;
  width: 8px;
  height: 8px;
  aspect-ratio: 1;
  border-radius: 50%;

  &.light {
    animation: light 1s infinite linear alternate;
  }

  &.dark {
    animation: dark 1s infinite linear alternate;
  }
}

@keyframes light {
  0% {
    box-shadow:
      10px 0 #000,
      -10px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow:
      10px 0 #000,
      -10px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow:
      10px 0 #0002,
      -10px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow:
      10px 0 #0002,
      -10px 0 #000;
    background: #000;
  }
}
@keyframes dark {
  0% {
    box-shadow:
      10px 0 #fff,
      -10px 0 #fffa;
    background: #fff;
  }
  33% {
    box-shadow:
      10px 0 #fff,
      -10px 0 #fffa;
    background: #fffa;
  }
  66% {
    box-shadow:
      10px 0 #fffa,
      -10px 0 #fff;
    background: #fffa;
  }
  100% {
    box-shadow:
      10px 0 #fffa,
      -10px 0 #fff;
    background: #fff;
  }
}
